// autogenerated by channel_search/generate.py -- do not edit
import { CaptureSettings } from "@skydio/pbtypes/pbtypes/vehicle/infrastructure/flight_deck/settings_pb";
export { CaptureSettings };

export const UPDATE_CAPTURE_SETTINGS_PB = {
  channel: "UPDATE_CAPTURE_SETTINGS_PB",
  channelId: 7547,
  type: CaptureSettings.deserializeBinary
};
